import {
  Injectable,
} from '@angular/core';
import {
  JourneysStore,
} from '@des/store/journeys';
import {
  Store,
} from '@ngrx/store';
import {
  FactsService,
  RulesEngineRunnerService,
} from '@o3r/rules-engine';
import {
  getArrivalCityCode,
  getArrivalCountryCode,
  getArrivalLocationCode,
  getDepartureCityCode,
  getDepartureCountryCode,
  getDepartureLocationCode,
  getFirstJourneyDepartureCityCode,
  getFirstJourneyDepartureCountryCode,
  getFirstJourneyDepartureLocationCode,
  getJourneys,
  getLastJourneyArrivalCityCode,
  getLastJourneyArrivalCountryCode,
  getLastJourneyArrivalLocationCode,
  getSelectedJourney,
} from './fact-factories/index';
import {
  JourneyInformationFacts,
} from './journey-information.facts';

@Injectable()
export class JourneyInformationFactsService extends FactsService<JourneyInformationFacts> {
  public facts = {
    arrCityCode: this.store.pipe(getArrivalCityCode()),
    arrCountryCode: this.store.pipe(getArrivalCountryCode()),
    arrLocationCode: this.store.pipe(getArrivalLocationCode()),
    depCityCode: this.store.pipe(getDepartureCityCode()),
    depCountryCode: this.store.pipe(getDepartureCountryCode()),
    depLocationCode: this.store.pipe(getDepartureLocationCode()),
    journeys: this.store.pipe(getJourneys()),
    selectedJourney: this.store.pipe(getSelectedJourney()),
    firstJourneyDepCityCode: this.store.pipe(getFirstJourneyDepartureCityCode()),
    firstJourneyDepCountryCode: this.store.pipe(getFirstJourneyDepartureCountryCode()),
    firstJourneyDepLocationCode: this.store.pipe(getFirstJourneyDepartureLocationCode()),
    lastJourneyArrCityCode: this.store.pipe(getLastJourneyArrivalCityCode()),
    lastJourneyArrCountryCode: this.store.pipe(getLastJourneyArrivalCountryCode()),
    lastJourneyArrLocationCode: this.store.pipe(getLastJourneyArrivalLocationCode())
  };

  constructor(rulesEngine: RulesEngineRunnerService, private readonly store: Store<JourneysStore>) {
    super(rulesEngine);
  }
}
